import SvgIcon from "@mui/material/SvgIcon";
import type React from "react";

export default function PeopleIcon({ className }: { className?: string }): React.ReactNode {
  return (
    <SvgIcon focusable="false" viewBox="0 0 24 24" role="presentation" className={className}>
      <path
        d="M11.99 2m3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
        style={{ transform: "scale(1.2) translate(-2px, -2px)" }}
      ></path>
    </SvgIcon>
  );
}
